const DRAFT_PREFIX = 'optima:draft:';
const EXPIRY_MS = 24 * 60 * 60 * 1000; // 24 hours

interface DraftEntry<T> {
    data: T;
    savedAt: number;
}

export function getDraft<T>(key: string): T | null {
    try {
        const raw = localStorage.getItem(DRAFT_PREFIX + key);
        if (!raw) return null;
        const entry: DraftEntry<T> = JSON.parse(raw);
        if (Date.now() - entry.savedAt > EXPIRY_MS) {
            localStorage.removeItem(DRAFT_PREFIX + key);
            return null;
        }
        return entry.data;
    } catch {
        localStorage.removeItem(DRAFT_PREFIX + key);
        return null;
    }
}

export function saveDraft<T>(key: string, data: T): void {
    try {
        const entry: DraftEntry<T> = { data, savedAt: Date.now() };
        localStorage.setItem(DRAFT_PREFIX + key, JSON.stringify(entry));
    } catch {
        // silent fail - localStorage may be full or unavailable
    }
}

export function clearDraft(key: string): void {
    localStorage.removeItem(DRAFT_PREFIX + key);
}

export function clearAllDrafts(): void {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key?.startsWith(DRAFT_PREFIX)) {
            keysToRemove.push(key);
        }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
}
